import { useQuery } from '@tanstack/react-query';

import { UserActionEvent } from 'src/features/userAction/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/logs/user-action-event/:eventId/';

type QueryFnType = typeof queryFn;

type DTO = {
    parkingId: string;
    eventId: string;
};

const queryFn = ({ parkingId, eventId }: DTO): Promise<UserActionEvent> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, eventId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetUserActionEvent };
